import { TODO } from '@b2b/types/core/utils';
import { Ng1StateDeclaration } from '@uirouter/angularjs';
import angular from 'angular';

interface FeatureObjectLockItem {
  ids: string[];
  views: string[];
}

export class FeatureObjectLockService {
  static $inject = ['LockApiService'];

  readonly name = 'objectLock';
  readonly key = 'lockAlwaysRequiredToUpdateRequiresLockObjects';

  api = this.LockApiService;
  items: FeatureObjectLockItem[] = [];

  constructor(private LockApiService: TODO) {}

  init() {
    this.reset();
    return true;
  }

  reset() {
    this.items = [];
  }

  add(props: { id: TODO; views: TODO[] }) {
    const found = this.findView(props.views);

    if (!found) {
      this.items.push({
        views: props.views,
        ids: [props.id],
      });
    } else if (!this.hasLock(found.view, props.id)) {
      const item = this.items[found.index];
      item.ids.push(props.id);
    }
  }

  remove(props: { id: TODO; view: string | undefined }) {
    const found = this.findView([props.view]);
    const foundId = this.hasLock(props.view, props.id);
    let r: TODO | false = false;

    if (found && foundId) {
      r = this.items[found.index].ids.length;

      const item = this.items[found.index];
      item.ids.splice(foundId.index, 1);

      if (item.ids.length <= 0) {
        this.items.splice(found.index, 1);
      }
    }

    return r;
  }

  /**
   * if `to` has object lock enabled.
   */
  isEligible(state: Ng1StateDeclaration, params: { [paramName: string]: any }) {
    return state.data && state.data.features && state.data.features.objectLock && state.data.features.objectLock.type;
  }

  hasLock(state: TODO, id: TODO) {
    if (state && id) {
      const found = this.findView([state]);
      const item = found ? this.items[found.index] : undefined;

      if (item && Array.isArray(item.ids)) {
        const foundIdIndex = item.ids.indexOf(id);

        if (foundIdIndex > -1) {
          return { index: foundIdIndex };
        }
      }
    }

    return false;
  }

  /**
   * if to is not in items[x].views list and if from has a lock right now
   */
  canRelease(sourceState: TODO, srcParams: TODO, destinationState: TODO, destParams: TODO) {
    const destinationName = destinationState && destinationState.name;
    return destinationName && !this.findView([destinationState.name]) && this.hasLock(sourceState.name, srcParams.id);
  }

  /*
   * Is the stateName part of any current views
   */
  includesView(list: TODO[], stateName: string) {
    list = list || [];

    for (let i = 0, ii = list.length; i < ii; i++) {
      const re = new RegExp('^' + list[i] + '.*');
      if (re.test(stateName)) {
        return list[i];
      }
    }

    return false;
  }

  findView(stateNames: TODO[]) {
    let r: { index: number; view: TODO } | false = false;

    for (let i = 0, ii = this.items.length; i < ii && !r; i++) {
      const views = this.items[i].views;
      if (Array.isArray(stateNames)) {
        for (let j = 0, jj = stateNames.length; j < jj; j++) {
          const testState = stateNames[i];
          const result = this.includesView(views, testState);

          if (result) {
            r = { index: i, view: result };
            break;
          }
        }
      }
    }

    return r;
  }
}

export const FeatureObjectLockServiceModule = angular
  .module('acme.common.service.objectLock', ['acme.common.service.lockApi'])
  .service('FeatureObjectLockService', FeatureObjectLockService).name;
